import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class PayrollVariableInstance  {
    _originalTypeClassName = "zERP.BO.PayrollVariableInstance";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
PayrollVariableInstance.translate = translateService;
}
this.HistoryEntries = [];
this.Id = null;
this.Value = null;
this.UpdatedByUser = false;
this.SystemCalculatedValue = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Value:any;
UpdatedByUser:any;
SystemCalculatedValue:any;
Variable:any;
Payroll:any;
HistoryEntries:any;
static setVariable = ($this, value) => {
var oldValue = $this.Variable;
$this.Variable = value;
if (value != null) {
}
}
static setPayroll = ($this, value) => {
var oldValue = $this.Payroll;
$this.Payroll = value;
if (value != null) {
if (oldValue != null) {
Domain.EmployeePayroll.removeVariables(oldValue, $this);
}
Domain.EmployeePayroll.addVariables(value, $this);
}
}
static setHistoryEntries = ($this, items) => {
                if (items == null) items = [];
                if ($this.HistoryEntries == null) $this.HistoryEntries = [];

                const copyItems = Common.cloneObject(items);

                while ($this.HistoryEntries.length > 0) {
                    Domain.PayrollVariableInstance.removeHistoryEntries($this, $this.HistoryEntries[0]);
                }

                Domain.PayrollVariableInstance.addManyHistoryEntries($this, copyItems);
            }
static addManyHistoryEntries = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.PayrollVariableInstance.addHistoryEntries($this, items[i]);
                }
            }
static addHistoryEntries = ($this, item) => {
                if ($this.HistoryEntries == null) $this.HistoryEntries = [];
                if (item == null || $this.HistoryEntries.indexOf(item) > -1) return;
                $this.HistoryEntries.push(item);
}
static addRangeHistoryEntries = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.PayrollVariableInstance.addHistoryEntries($this, item));
            }
static removeHistoryEntries = ($this, item) => {
                if ($this == null || $this.HistoryEntries == null || $this.HistoryEntries.indexOf(item) === -1) return;
                var _index = $this.HistoryEntries.indexOf(item);
                $this.HistoryEntries.splice(_index, 1);
}
static clearHistoryEntries = ($this) => { $this.HistoryEntries = null; }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}